<div>
  @if (withSearch) {
    <div class="search-section d-flex justify-content-between align-items-center">
      <div class="search-tooltip">
        @if (showTooltipText) {
          <div class="tooltip-wrapper d-flex">
            <p class="tooltip-text">
              {{ 'components.table.tooltipText' | translate }}
            </p>
            <app-tooltip [marginBottom]="true" [text]="tableTooltipText" position="bottom-right"></app-tooltip>
          </div>
        }
      </div>
      <div class="search-wrapper">
        <input
          class="search form-control lna"
          [(ngModel)]="searchValue"
          (ngModelChange)="search()"
          (keyup)="handleKeyPress($event)"
          type="text"
          placeholder="{{ getSearchPlaceholder() | translate }}" />
        <button class="clear-search" (click)="clearSearch()">
          <i class="bi bi-x-lg"></i>
        </button>
        <button class="search-btn" (click)="search()">
          <img src="assets/images/search-icon.svg" alt="search" />
        </button>
      </div>
    </div>
  }
  @if (topFilterOptions.length) {
    <div class="top-filter-section" [ngClass]="{ 'no-search': !withSearch }">
      <div class="top-filter-options">
        @for (option of topFilterOptions; track option) {
          <label class="top-filter-option">
            <input
              class="form-check-input lna checkbox"
              type="checkbox"
              [checked]="topFilterSelected.has(option)"
              (change)="toggleTopFilter(option)" />
            {{ topFilterTranslatePrefix + option | translate }}
            ({{ getTopFilterCount(option) }})
          </label>
        }
      </div>
      <div class="top-filter-actions">
        @if (topFilterSelected.size < topFilterOptions.length) {
          <button class="top-filter-link-btn" (click)="selectAllTopFilters()">
            {{ 'pages.infoRequestWorkspace.statusFilter.selectAll' | translate }}
          </button>
        }
        @if (topFilterSelected.size > 0) {
          <button class="top-filter-link-btn" (click)="deselectAllTopFilters()">
            {{ 'pages.infoRequestWorkspace.statusFilter.deselectAll' | translate }}
          </button>
        }
      </div>
    </div>
  }
  <div class="table-wrapper" #tableWrapper [ngClass]="{ 'with-search': withSearch, 'flat-top': !withSearch && !topFilterOptions.length }">
    <table>
      <thead>
        <tr>
          @for (column of columns; track (column.sortKey || column.key)) {
            <th [ngClass]="[column.columnClass ? column.columnClass : '']" [attr.id]="'header-' + (column.sortKey || column.key)">
              <div class="th-wrapper">
                <div class="th-wrapper_title">
                  {{ column.name | translate }}
                  @if (column.tooltipText) {
                    <app-tooltip [marginBottom]="false" text="{{ column.tooltipText }}" position="bottom-right" />
                  }
                </div>
                <div class="column-controls">
                  @if (column.filter) {
                    <button [ngClass]="['filter-btn', this.sortBy === column.key ? 'asc' : 'dsc']" (click)="toggleFilterOverlay(column)">
                      @if (column.filter !== 'search') {
                        @if (isFilterActive(column)) {
                          <img src="assets/images/filter-icon-active.svg" alt="filter" />
                        } @else {
                          <img src="assets/images/filter-icon.svg" alt="filter" />
                        }
                      } @else {
                        @if (isFilterActive(column)) {
                          <img src="assets/images/search-icon-active.svg" alt="search" />
                        } @else {
                          <img src="assets/images/search-icon-gray.svg" alt="search" />
                        }
                      }
                    </button>
                  }
                  @if (column.sortEnabled) {
                    @if (this.sortBy === column.sortKey || (!column.sortKey && this.sortBy === column.key)) {
                      <button [ngClass]="['sort-btn', this.sortDirection === 'asc' ? 'asc' : 'dsc']" (click)="sort(column)">
                        <img src="assets/images/sort-active-icon.svg" alt="sort" />
                      </button>
                    } @else {
                      <button class="sort-btn" (click)="sort(column)">
                        <img src="assets/images/sort-inactive-icon.svg" alt="sort" />
                      </button>
                    }
                  }
                </div>
              </div>
            </th>
          }
          @if (rowActions.length) {
            <th class="actions"></th>
          }
        </tr>
      </thead>
      @if (!isLoading) {
        <tbody class="body" [ngClass]="{ loading: isLoading }">
          @for (row of pagedResult.list; track row) {
            <tr
              [ngClass]="{
                clickable: (viewEntryPath || editEntryPath || isEntryPathForSubmittion || getViewPathFn),
                'restricted-row': row['requiresRestrictedAccess'],
                'task-row-overdue': getTaskDateStatus(row) === 'overdue',
                'task-row-approaching': getTaskDateStatus(row) === 'approaching',
                'task-row-disabled': row['status'] === 'Completed' || row['status'] === 'Cancelled'
              }"
              (click)="(viewEntryPath || editEntryPath || isEntryPathForSubmittion || getViewPathFn) ? handleAction(row.id, 'view', row, $event) : null"
              tabindex="0">
              @for (column of columns; track (column.sortKey || column.key)) {
                <td
                  class="table-data"
                  [ngClass]="[
                    column.styleClass || '',
                    getCellClassName(column, row),
                    column.columnClass || '',
                    column.conditionalRenderKey && row[column.conditionalRenderKey] ? 'render-icon' : '',
                    row.isRead === false ? 'bold-text' : ''
                  ]">
                  @if (linkRow) {
                    @if (column.renderInnerHtml) {
                    <a><p [ngClass]="[column.styleClass || '', getCellClassName(column, row)]"
                      [innerHTML]="getCellValue(row, column.key)"></p></a>
                    } @else{
                      <a
                        [href]="viewEntryPath ? viewEntryPath.replace('{id}', row.id?.toString()) : null"
                        [ngClass]="!viewEntryPath ? 'disabled-link' : ''">
                          <p [ngClass]="[column.styleClass || '', getCellClassName(column, row)]">
                            @if (column.customLogic === 'taskExecutionDate') {
                              @if (!getCellValue(row, column.key) || getCellValue(row, column.key) === '0001-01-01T00:00:00') {
                                -
                              } @else {
                                <span
                                  [ngClass]="{
                                    'task-date-overdue': getTaskDateStatus(row) === 'overdue',
                                    'task-date-approaching': getTaskDateStatus(row) === 'approaching'
                                  }">
                                  {{ formatDate(getCellValue(row, column.key)) }}
                                  @if (getTaskDateStatus(row) === 'overdue') {
                                    <i class="bi bi-exclamation-triangle-fill overdue-icon"></i>
                                  } @else if (getTaskDateStatus(row) === 'approaching') {
                                    <i class="bi bi-exclamation-triangle-fill approaching-icon"></i>
                                  }
                                </span>
                              }
                            } @else if (column.type === 'date' || column.type === 'dateTime') {
                              @if (getCellValue(row, column.key) === '0001-01-01T00:00:00') {
                                -
                              } @else {
                                {{
                                  column.type === 'dateTime'
                                    ? formatDate(getCellValue(row, column.key), false)
                                    : formatDate(getCellValue(row, column.key))
                                }}
                              }
                            } @else if (column.customLogic === 'activeAbsence') {
                              @if (row[column.key]) {
                                {{ formatDate(getCellValue(row, column.key).periodStart) }}
                                - {{ formatDate(row[column.key].periodEnd) }}
                              } @else {
                                -
                              }
                            } @else if (column.type === 'image' && row[column.key]) {
                              <img src="{{ getImageUrl(row[column.key]) }}" alt="image" />
                            } @else if (column.customLogic === 'identifier') {
                              @if (row[column.key]) {
                                {{ formatIdentityNumber(getCellValue(row, column.key)) }}
                              } @else {
                                -
                              }
                            } @else if (column.type === 'time') {
                              {{ getCellValue(row, column.key).substring(0, 5) }}
                            } @else if (column.customLogic === 'auditResult') {
                              <button class="link-btn link" (click)="handleAction(row.id, 'auditResult', row)">
                                {{ 'pages.audit.fullDetails' | translate }}
                              </button>
                            } @else if (column.customLogic === 'orgNameWithType') {
                              {{ row.name }}{{ row.type ? ', ' + ('pages.organization.legalEntityForms.' + row.type | translate) : '' }}
                            } @else if (column.customLogic === 'arrayJoin') {
                              {{ getArrayJoinValue(row, column.key) }}
                            } @else if (column.customLogic === 'assigneeWithCodes') {
                              {{ getAssigneeWithCodes(row) }}
                            } @else if (column.customLogic === 'deadlineWithDate') {
                              @if (getCellValue(row, 'serviceDeadline') === 'Other') {
                                {{ formatDate(getCellValue(row, 'deadlineDate')) }}
                              } @else {
                                {{ getCellValue(row, 'serviceDeadline') ? ('pages.service.infoRequest.deadline.' + getCellValue(row, 'serviceDeadline') | translate) : '-' }}
                              }
                            } @else if (column.customLogic === 'boolean') {
                              {{ getCellValue(row, column.key) === true ? ('components.table.yes' | translate) : (getCellValue(row, column.key) === false ? ('components.table.no' | translate) : '-') }}
                            } @else if (column.customLogic === 'topicWithRestriction') {
                              <span [ngClass]="{ 'restricted-topic-text': row['requiresRestrictedAccess'] }">{{ getCellValue(row, column.key) || '-' }}</span>
                              @if (row['requiresRestrictedAccess']) {
                                <span class="restricted-access-badge"><i class="bi bi-lock-fill"></i> IP</span>
                              }
                            } @else if (column.customLogic === 'taskRequestLink') {
                              <a class="task-request-link" (click)="emitCustomAction('viewRequest', row, $event)">
                                {{ getCellValue(row, column.key) }}
                              </a>
                            } @else if (column.customLogic === 'taskActions') {
                              <span class="task-actions-cell">
                                @if (row['status'] === 'Assigned' || (row['status'] === 'Accepted' && !row['assigneeUserFullName'])) {
                                  <button class="secondary small-btn" (click)="emitCustomAction('accept', row, $event)">
                                    {{ 'pages.infoRequestWorkspace.taskActions.accept' | translate }}
                                  </button>
                                }
                                @if (row['status'] === 'Accepted' && row['assigneeUserFullName']) {
                                  <button class="secondary small-btn" (click)="emitCustomAction('complete', row, $event)">
                                    {{ 'pages.infoRequestWorkspace.taskActions.complete' | translate }}
                                  </button>
                                }
                                @if (row['status'] === 'Waiting' || row['status'] === 'Assigned' || row['status'] === 'Accepted') {
                                  <button class="secondary small-btn cancel-btn" (click)="emitCustomAction('cancel', row, $event)">
                                    {{ 'pages.infoRequestWorkspace.taskActions.cancel' | translate }}
                                  </button>
                                }
                              </span>
                            } @else if (column.customLogic === 'taskActionsAcceptOnly') {
                              <span class="task-actions-cell">
                                @if (row['status'] === 'Assigned' || row['status'] === 'Accepted') {
                                  <button class="secondary small-btn" (click)="emitCustomAction('accept', row, $event)">
                                    {{ 'pages.infoRequestWorkspace.taskActions.accept' | translate }}
                                  </button>
                                }
                              </span>
                            } @else {
                              {{
                                column.valueTranslate
                                  ? (getTranslateKey(column, row) | translate)
                                  : getCellValue(row, column.key)
                              }}
                            }
                          </p>
                      </a>
                    }
                  } @else {
                    @if (column.renderInnerHtml) {
                      <p [ngClass]="[column.styleClass || '', getCellClassName(column, row)]"
                        [innerHTML]="getCellValue(row, column.key)">
                    } @else {
                      <p [ngClass]="[column.styleClass || '', getCellClassName(column, row)]">
                        @if (column.customLogic === 'taskExecutionDate') {
                          @if (!getCellValue(row, column.key) || getCellValue(row, column.key) === '0001-01-01T00:00:00') {
                            -
                          } @else {
                            <span
                              [ngClass]="{
                                'task-date-overdue': getTaskDateStatus(row) === 'overdue',
                                'task-date-approaching': getTaskDateStatus(row) === 'approaching'
                              }">
                              {{ formatDate(getCellValue(row, column.key)) }}
                              @if (getTaskDateStatus(row) === 'overdue') {
                                <i class="bi bi-exclamation-triangle-fill overdue-icon"></i>
                              } @else if (getTaskDateStatus(row) === 'approaching') {
                                <i class="bi bi-exclamation-triangle-fill approaching-icon"></i>
                              }
                            </span>
                          }
                        } @else if (column.type === 'date' || column.type === 'dateTime') {
                          @if (getCellValue(row, column.key) === '0001-01-01T00:00:00') {
                            -
                          } @else {
                            {{
                              column.type === 'dateTime'
                                ? formatDate(getCellValue(row, column.key), false)
                                : formatDate(getCellValue(row, column.key))
                            }}
                          }
                        } @else if (column.customLogic === 'activeAbsence') {
                          @if (row[column.key]) {
                            {{ formatDate(getCellValue(row, column.key).periodStart) }}
                            - {{ formatDate(row[column.key].periodEnd) }}
                          } @else {
                            -
                          }
                        } @else if (column.type === 'image' && row[column.key]) {
                          <img src="{{ getImageUrl(row[column.key]) }}" alt="image" />
                        } @else if (column.customLogic === 'identifier') {
                          @if (row[column.key]) {
                            {{ formatIdentityNumber(getCellValue(row, column.key)) }}
                          } @else {
                            -
                          }
                        } @else if (column.type === 'time') {
                          {{ getCellValue(row, column.key).substring(0, 5) }}
                        } @else if (column.customLogic === 'auditResult') {
                          <button class="link-btn link" (click)="handleAction(row.id, 'auditResult', row)">
                            {{ 'pages.audit.fullDetails' | translate }}
                          </button>
                        } @else if (column.customLogic === 'jsonUserName') {
                          {{ getJsonValue(row, column) }}
                        } @else if (column.customLogic === 'jsonIpAddress') {
                          {{ getJsonValue(row, column) }}
                        } @else if (column.customLogic === 'jsonSystem') {
                          {{ getJsonValue(row, column) }}
                        } @else if (column.customLogic === 'orgNameWithType') {
                          {{ row.name }}{{ row.type ? ', ' + ('pages.organization.legalEntityForms.' + row.type | translate) : '' }}
                        } @else if (column.customLogic === 'arrayJoin') {
                          {{ getArrayJoinValue(row, column.key) }}
                        } @else if (column.customLogic === 'assigneeWithCodes') {
                          {{ getAssigneeWithCodes(row) }}
                        } @else if (column.customLogic === 'deadlineWithDate') {
                          @if (getCellValue(row, 'serviceDeadline') === 'Other') {
                            {{ formatDate(getCellValue(row, 'deadlineDate')) }}
                          } @else {
                            {{ getCellValue(row, 'serviceDeadline') ? ('pages.service.infoRequest.deadline.' + getCellValue(row, 'serviceDeadline') | translate) : '-' }}
                          }
                        } @else if (column.customLogic === 'boolean') {
                          {{ getCellValue(row, column.key) === true ? ('components.table.yes' | translate) : (getCellValue(row, column.key) === false ? ('components.table.no' | translate) : '-') }}
                        } @else if (column.customLogic === 'topicWithRestriction') {
                          <span>{{ getCellValue(row, column.key) || '-' }}</span>
                          @if (row['requiresRestrictedAccess']) {
                            <span class="restricted-access-badge"><i class="bi bi-lock-fill"></i> IP</span>
                          }
                        } @else if (column.customLogic === 'taskRequestLink') {
                          <a class="task-request-link" (click)="emitCustomAction('viewRequest', row, $event)">
                            {{ getCellValue(row, column.key) }}
                          </a>
                        } @else if (column.customLogic === 'taskActions') {
                          <span class="task-actions-cell">
                            @if (row['status'] === 'Assigned' || (row['status'] === 'Accepted' && !row['assigneeUserFullName'])) {
                              <button class="secondary small-btn" (click)="emitCustomAction('accept', row, $event)">
                                {{ 'pages.infoRequestWorkspace.taskActions.accept' | translate }}
                              </button>
                            }
                            @if (row['status'] === 'Accepted' && row['assigneeUserFullName']) {
                              <button class="secondary small-btn" (click)="emitCustomAction('complete', row, $event)">
                                {{ 'pages.infoRequestWorkspace.taskActions.complete' | translate }}
                              </button>
                            }
                            @if (row['status'] === 'Waiting' || row['status'] === 'Assigned' || row['status'] === 'Accepted') {
                              <button class="secondary small-btn cancel-btn" (click)="emitCustomAction('cancel', row, $event)">
                                {{ 'pages.infoRequestWorkspace.taskActions.cancel' | translate }}
                              </button>
                            }
                          </span>
                        } @else if (column.customLogic === 'taskActionsAcceptOnly') {
                          <span class="task-actions-cell">
                            @if (row['status'] === 'Assigned') {
                              <button class="secondary small-btn" (click)="emitCustomAction('accept', row, $event)">
                                {{ 'pages.infoRequestWorkspace.taskActions.accept' | translate }}
                              </button>
                            }
                          </span>
                        } @else {
                          {{
                            column.valueTranslate
                              ? (getTranslateKey(column, row) | translate)
                              : getCellValue(row, column.key)
                          }}
                        }
                      </p>
                    }
                  }
                </td>
              }
              @if (rowActions.length) {
                <td [ngClass]="actionColumnStyleClass || ''">
                  @if (rowActions.includes('view')) {
                    <button class="secondary view-btn" (click)="handleAction(row.id, 'view', row)">
                      <img src="assets/images/view-icon.svg" alt="view" />
                      {{ 'components.table.view' | translate }}
                    </button>
                  }
                  @if (rowActions.includes('open')) {
                    <button class="secondary view-btn" (click)="handleAction(row.id)">
                      <img src="assets/images/view-icon.svg" alt="view" />
                      {{ 'components.table.open' | translate }}
                    </button>
                  }
                  @if (rowActions.includes('edit')) {
                    <button class="secondary view-btn" (click)="handleAction(row.id, 'edit')">
                      <img src="assets/images/edit-icon.svg" alt="view" />
                      {{ 'components.table.edit' | translate }}
                    </button>
                  }
                  @if (rowActions.includes('isRead')) {
                    @if (!row.isRead) {
                      <button class="secondary mark-as-read" (click)="handleAction(row.id, 'read')">
                        <img src="assets/images/double-check.svg" alt="view" />
                        {{ 'components.table.markAsRead' | translate }}
                      </button>
                    } @else {
                      <button class="button-link" (click)="handleAction(row.id, 'unread')">
                        {{ 'components.table.markAsUnread' | translate }}
                      </button>
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      }
      @if (!pagedResult?.list?.length && !isLoading) {
        <div class="empty-table">
          <p>{{ 'components.table.empty' | translate }}</p>
        </div>
      }
    </table>
    <div class="loader-wrapper" #loader [ngClass]="{ loading: isLoading }">
      <app-spinner [isLoading]="isLoading" />
    </div>
  </div>
  @if (!isLoading && (pagedResult?.totalCount ?? 0) > 10) {
    <div class="pagination-wrapper">
      <p class="total">{{ 'components.table.total' | translate }} {{ pagedResult.totalCount }}</p>
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="pagedResult.totalCount"
        [maxSize]="5"
        [ellipses]="true"
        (pageChange)="handlePageChange()" />
      <select class="page-size" (change)="onPageSizeChange($event)">
        <option [selected]="pageSize === 10" [value]="10">10 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 20" [value]="20">20 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 50" [value]="50">50 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 100" [value]="100">100 / {{ 'components.table.pageSize' | translate }}</option>
      </select>
    </div>
  }
  <div class="table-wrapper invisible" [ngClass]="{ 'd-none': !isLoading }">
    <table>
      @if (withSearch) {
        <div class="search-section d-flex justify-content-between align-items-center">
          <div class="search-tooltip">
            @if (showTooltipText) {
              <div class="tooltip-wrapper d-flex">
                <p class="m-0 form-value">
                  {{ 'components.table.tooltipText' | translate }}
                </p>
                <app-tooltip [marginBottom]="true" position="bottom-right"></app-tooltip>
              </div>
            }
          </div>
          <div class="search-wrapper">
            <input
              class="search"
              class="form-control lna"
              [(ngModel)]="searchValue"
              (keyup)="handleKeyPress($event)"
              type="text"
              placeholder="{{ getSearchPlaceholder() | translate }}" />
            <button class="clear-search" (click)="clearSearch()">
              <img src="assets/images/close-icon.svg" alt="clear" />
            </button>
            <button class="search-btn" (click)="search()">
              <img src="assets/images/search-icon.svg" alt="search" />
            </button>
          </div>
        </div>
      }
      <thead>
        <tr>
          @for (column of columns; track (column.sortKey || column.key)) {
            <th>
              <div class="th-wrapper">
                <span>{{ column.name | translate }}</span>
                <div class="column-controls">
                  @if (column.filter) {
                    <button [ngClass]="['filter-btn', this.sortBy === column.key ? 'asc' : 'dsc']" (click)="toggleFilterOverlay(column)">
                      <img src="assets/images/filter-icon.svg" alt="sort" />
                    </button>
                    @if (tableFilters[column.sortKey || column.key].isOpen && column.filter === 'multiSelect') {
                      <div class="column-filter-overlay multi-select">
                        <div class="input-wrapper all">
                          <input
                            class="form-check-input lna checkbox"
                            [id]="column.key + '_all'"
                            [name]="column.key + '_all'"
                            (change)="handleMultiSelectFilter(column, 'all')"
                            type="checkbox" />
                          <label class="form-label lna" for="{{ column.key + '_all' }}">
                            {{ 'components.table.selectAll' | translate }}
                          </label>
                        </div>
                        @for (value of column.filterOptions; track value) {
                          <div class="input-wrapper">
                            <input
                              class="form-check-input lna checkbox"
                              [id]="column.key + '_' + value"
                              [name]="column.key + '_' + value"
                              (change)="handleMultiSelectFilter(column, value)"
                              type="checkbox" />
                            <label class="form-label lna" for="{{ column.key + '_' + value }}">
                              @if (column.filterOptionLabels?.has(value)) {
                                {{ column.filterOptionLabels!.get(value) }}
                              } @else if (column.dynamicFilterOptionsField) {
                                {{ value }}
                              } @else if (column.valueTranslate) {
                                {{ column.valueTranslate + value | translate }}
                              } @else {
                                {{ 'components.table.' + value | translate }}
                              }
                            </label>
                          </div>
                        }
                        <div class="filter-overlay-actions">
                          <!-- here -->
                          <button class="primary" (click)="applyFilter(column)">
                            {{ 'components.table.filter' | translate }}
                          </button>
                          <button class="secondary" (click)="removeFilter(column)">
                            {{ 'components.table.removeFilter' | translate }}
                          </button>
                          <button class="secondary close" (click)="toggleFilterOverlay(column)">
                            {{ 'components.table.closeFilter' | translate }}
                          </button>
                        </div>
                      </div>
                    }
                  }
                  @if (column.sortEnabled) {
                    @if (this.sortBy === column.sortKey || (!column.sortKey && this.sortBy === column.key)) {
                      <button [ngClass]="['sort-btn', this.sortBy === column.key ? 'asc' : 'dsc']" (click)="sort(column)">
                        <img src="assets/images/sort-active-icon.svg" alt="sort" />
                      </button>
                    } @else {
                      <button class="sort-btn" (click)="sort(column)">
                        <img src="assets/images/sort-inactive-icon.svg" alt="sort" />
                      </button>
                    }
                  }
                </div>
              </div>
            </th>
          }
          <th class="actions"></th>
        </tr>
      </thead>
      <tbody class="body" #tableBody [ngClass]="{ loading: isLoading }">
        @for (row of pagedResult?.list; track row) {
          <tr>
            @for (column of columns; track (column.sortKey || column.key)) {
              <td>
                <p [ngClass]="[column.styleClass || '', getCellClassName(column, row)]">
                  @if (column.type === 'date') {
                    {{ formatDate(row[column.key]) }}
                  } @else if (column.type === 'dateTime') {
                    {{ formatDate(row[column.key], false) }}
                  } @else {
                    {{ column.valueTranslate ? (getTranslateKey(column, row) | translate) : row[column.key] }}
                  }
                </p>
              </td>
            }
            <td>
              @if (rowActions.includes('view')) {
                <button class="secondary view-btn" (click)="handleAction(row.id)">
                  <img src="assets/images/view-icon.svg" alt="view" />
                  {{ 'components.table.view' | translate }}
                </button>
              }
              @if (rowActions.includes('open')) {
                <button class="secondary view-btn" (click)="handleAction(row.id)">
                  <img src="assets/images/view-icon.svg" alt="view" />
                  {{ 'components.table.open' | translate }}
                </button>
              }
              @if (rowActions.includes('edit')) {
                <button class="secondary view-btn" (click)="handleAction(row.id, 'edit')">
                  <img src="assets/images/edit-icon.svg" alt="view" />
                  {{ 'components.table.edit' | translate }}
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="filter-overlays">
    @for (column of columns; track (column.sortKey || column.key)) {
      @if (column.filter === 'multiSelect') {
        <div
          class="column-filter-overlay multi-select"
          [attr.id]="'filter-overlay-' + (column.sortKey || column.key)"
          [ngClass]="{ open: tableFilters[column.sortKey || column.key].isOpen }"
          (keydown.enter)="handleOverlayEnter(column, $event)"
          aria-label="Filter options">
          <div class="input-wrapper all">
            <input
              class="form-check-input lna checkbox"
              [id]="column.key + '_all'"
              [name]="column.key + '_all'"
              [checked]="isFilterChecked(column, 'all')"
              (change)="handleMultiSelectFilter(column)"
              type="checkbox" />
            <label class="form-label lna" for="{{ column.key + '_all' }}">
              {{ 'components.table.selectAll' | translate }}
            </label>
          </div>
          @for (value of column.filterOptions; track value) {
            <div class="input-wrapper">
              <input
                class="form-check-input lna checkbox"
                [id]="column.key + '_' + value"
                [name]="column.key + '_' + value"
                [checked]="isFilterChecked(column, value)"
                (change)="handleMultiSelectFilter(column, value)"
                type="checkbox" />
              <label class="form-label lna" for="{{ column.key + '_' + value }}">
                @if (column.filterOptionLabels?.has(value)) {
                  {{ column.filterOptionLabels!.get(value) }}
                } @else if (column.multiselectFilterName === 'readingRoomCodes' || column.dynamicFilterOptionsField){
                  {{ value }}
                } @else if (column.valueTranslate) {
                  {{ column.valueTranslate + value | translate }}
                } @else {
                  {{ 'components.table.' + value | translate }}
                }
              </label>
            </div>
          }
          @if (column.dateFilterKey) {
            <div class="input-wrapper date-filter">
              <app-date-range-picker
                [pastDates]="true"
                [noMargin]="true"
                displayPosition="center"
                [resetTrigger]="tableFilters[column.dateFilterKey].resetTrigger"
                (rangeChanged)="onDateRangeChange($event, column, column.dateFilterKey)" />
            </div>
          }
          <div class="filter-overlay-actions">
            <button class="primary" (click)="applyFilter(column)">
              {{ 'components.table.filter' | translate }}
            </button>
            <button class="secondary" (click)="removeFilter(column)">
              {{ 'components.table.removeFilter' | translate }}
            </button>
            <button class="secondary close" (click)="toggleFilterOverlay(column)">
              {{ 'components.table.closeFilter' | translate }}
            </button>
          </div>
        </div>
      } @else if (column.filter === 'search' || column.filter === 'searchIdentityNumber') {
        <div
          class="column-filter-overlay search"
          [attr.id]="'filter-overlay-' + (column.sortKey || column.key)"
          [ngClass]="{ open: tableFilters[column.sortKey || column.key].isOpen }"
          (keydown.enter)="handleOverlayEnter(column, $event)">
          <div class="input-wrapper all">
            <input
              class="search"
              class="form-control lna"
              [(ngModel)]="tableFilters[column.sortKey || column.key].value"
              (keyup)="handleKeyPress($event)"
              type="text"
              placeholder="{{ 'components.table.search' | translate }}" />
          </div>
          <div class="filter-overlay-actions">
            <button class="primary" (click)="applyFilter(column)">
              {{ 'components.table.filter' | translate }}
            </button>
            <button class="secondary" (click)="removeFilter(column)">
              {{ 'components.table.removeFilter' | translate }}
            </button>
            <button class="secondary close" (click)="toggleFilterOverlay(column)">
              {{ 'components.table.closeFilter' | translate }}
            </button>
          </div>
        </div>
      } @else if (column.filter === 'date' || column.filter === 'dateTime') {
        <form
          class="column-filter-overlay date"
          (keydown.enter)="applyFilter(column)"
          [attr.id]="'filter-overlay-' + [column.sortKey || column.key]"
          [ngClass]="{ open: tableFilters[column.sortKey || column.key].isOpen }">
          <div class="input-wrapper">
            <app-date-range-picker
              [pastDates]="true"
              [noMargin]="true"
              [displayPosition]="$index > 1 ? 'center' : 'right'"
              [resetTrigger]="tableFilters[column.sortKey || column.key].resetTrigger"
              (rangeChanged)="onDateRangeChange($event, column)" />
          </div>
          <div class="filter-overlay-actions">
            <button class="primary" (click)="applyFilter(column)">
              {{ 'components.table.filter' | translate }}
            </button>
            <button class="secondary" (click)="removeFilter(column)">
              {{ 'components.table.removeFilter' | translate }}
            </button>
            <button class="secondary close" (click)="toggleFilterOverlay(column)">
              {{ 'components.table.closeFilter' | translate }}
            </button>
          </div>
        </form>
      } @else if (column.filter === 'time' || column.filter === 'timeUtc') {
        <div
          class="column-filter-overlay date"
          [attr.id]="'filter-overlay-' + [column.sortKey || column.key]"
          [ngClass]="{ open: tableFilters[column.sortKey || column.key].isOpen }">
          <div class="input-wrappe time-overlay-wrapper">
            <app-time-range-picker
              [resetTrigger]="tableFilters[column.sortKey || column.key].resetTrigger"
              (rangeChanged)="handleTimeRangeFilter(column, $event)"
              [from]="getTimeFrom(column)"
              [to]="getTimeTo(column)"/>
          </div>
          <div class="filter-overlay-actions">
            <button class="primary" (click)="applyFilter(column)">
              {{ 'components.table.filter' | translate }}
            </button>
            <button class="secondary" (click)="removeFilter(column)">
              {{ 'components.table.removeFilter' | translate }}
            </button>
            <button class="secondary close" (click)="toggleFilterOverlay(column)">
              {{ 'components.table.closeFilter' | translate }}
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>
<app-audit-entry-modal
  [auditEntry]="selectedAuditEntry"
  [isLoading]="isLoading"
  [isOpen]="isAuditEntryModalOpen"
  (cancel)="isAuditEntryModalOpen = false" />
